import { useState } from 'react';
import TrialModal from '../../../components/feature/TrialModal';

export default function JuniorHighSection() {
  const [activeGrade, setActiveGrade] = useState('國一');
  const [isTrialModalOpen, setIsTrialModalOpen] = useState(false);

  const coursesByGrade = {
    '國一': [
      {
        title: '國一數學班',
        image: 'https://public.readdy.ai/ai/img_res/8a926e8155a7117faa7b7aedfa0ae0d6.jpg',
        features: ['基礎代數', '幾何圖形', '數學邏輯', '解題技巧'],
        description: '建立紮實的數學基礎，培養邏輯思維能力，為國中數學打好根基。',
        schedule: '星期三晚上 18:00-21:00',
        weeklyTest: '週考：星期五晚上 18:00-21:00'
      },
      {
        title: '國一生物班',
        image: 'https://readdy.ai/api/search-image?query=Junior%20high%20school%20first%20year%20biology%20class%20with%20students%20aged%2012-13%20learning%20about%20cells%20and%20organisms%2C%20teenagers%20observing%20specimens%20with%20microscopes%2C%20modern%20science%20classroom%20with%20biology%20models%20and%20charts%2C%20bright%20clean%20white%20background%2C%20curious%20learning%20environment%2C%20educational%20equipment%20visible&width=400&height=300&seq=junior1-bio-new&orientation=landscape',
        features: ['細胞構造', '生物分類', '實驗操作', '科學觀察'],
        description: '探索生命科學的奧秘，透過實驗培養科學探究精神與觀察能力。',
        schedule: '星期四晚上 18:00-21:00',
        weeklyTest: '週考：星期五晚上 18:00-21:00'
      },
      {
        title: '國一英文班',
        image: 'https://readdy.ai/api/search-image?query=Junior%20high%20school%20first%20year%20English%20class%20with%20students%20aged%2012-13%20learning%20grammar%20and%20vocabulary%2C%20teenagers%20reading%20textbooks%20and%20practicing%20writing%2C%20organized%20classroom%20with%20educational%20posters%2C%20bright%20clean%20white%20background%2C%20focused%20learning%20atmosphere%2C%20study%20materials%20visible&width=400&height=300&seq=junior1-eng-new&orientation=landscape',
        features: ['基礎文法', '單字擴充', '聽力訓練', '口說練習'],
        description: '銜接國小課程，建立紮實的文法基礎，擴充字彙量，為國中三年打好基礎。',
        schedule: '星期一晚上 18:00-21:00',
        weeklyTest: '週考：星期五晚上 18:00-21:00'
      }
    ],
    '國二': [
      {
        title: '國二數學班',
        image: 'https://readdy.ai/api/search-image?query=Junior%20high%20school%20second%20year%20mathematics%20class%20with%20students%20aged%2013-14%20learning%20advanced%20algebra%20and%20geometry%2C%20teenagers%20solving%20complex%20equations%20on%20whiteboard%2C%20modern%20classroom%20with%20mathematical%20diagrams%2C%20bright%20clean%20white%20background%2C%20serious%20academic%20atmosphere%2C%20textbooks%20and%20calculators%20visible&width=400&height=300&seq=junior2-math-new&orientation=landscape',
        features: ['進階代數', '幾何證明', '函數概念', '應用題型'],
        description: '深化數學概念，加強解題能力，培養數學思維與邏輯推理能力。',
        schedule: '星期五晚上 18:00-21:00',
        weeklyTest: '週考：星期三晚上 18:00-21:00'
      },
      {
        title: '國二理化班',
        image: 'https://readdy.ai/api/search-image?query=Junior%20high%20school%20second%20year%20physics%20and%20chemistry%20class%20with%20students%20aged%2013-14%20doing%20experiments%2C%20teenagers%20learning%20with%20lab%20equipment%20and%20scientific%20instruments%2C%20modern%20science%20laboratory%20classroom%2C%20bright%20clean%20white%20background%2C%20educational%20experimental%20atmosphere%2C%20safety%20goggles%20and%20chemicals%20visible&width=400&height=300&seq=junior2-phy-new&orientation=landscape',
        features: ['物理原理', '化學反應', '實驗操作', '科學推理'],
        description: '理化觀念建立與實驗操作，培養科學素養與實驗技能。',
        schedule: '星期四晚上 18:00-21:00',
        weeklyTest: '週考：星期三晚上 18:00-21:00'
      },
      {
        title: '國二英文班',
        image: 'https://readdy.ai/api/search-image?query=Junior%20high%20school%20second%20year%20English%20class%20with%20students%20aged%2013-14%20in%20advanced%20learning%2C%20teenagers%20doing%20group%20discussions%20and%20reading%20comprehension%2C%20interactive%20classroom%20with%20books%20and%20materials%2C%20bright%20clean%20white%20background%2C%20engaged%20learning%20environment%2C%20educational%20resources%20visible&width=400&height=300&seq=junior2-eng-new&orientation=landscape',
        features: ['進階文法', '閱讀理解', '寫作技巧', '會話應用'],
        description: '深化文法概念，加強閱讀理解能力，開始培養英文寫作技巧與流暢會話。',
        schedule: '星期二晚上 18:00-21:00',
        weeklyTest: '週考：星期三晚上 18:00-21:00'
      }
    ],
    '國三': [
      {
        title: '國三數學班',
        image: 'https://readdy.ai/api/search-image?query=Junior%20high%20school%20third%20year%20mathematics%20class%20with%20students%20aged%2014-15%20preparing%20for%20entrance%20exam%2C%20teenagers%20solving%20advanced%20math%20problems%20intensively%2C%20organized%20classroom%20with%20exam%20practice%20materials%2C%20bright%20clean%20white%20background%2C%20serious%20exam%20preparation%20atmosphere%2C%20test%20papers%20and%20formulas%20visible&width=400&height=300&seq=junior3-math-new&orientation=landscape',
        features: ['會考準備', '綜合題型', '解題速度', '考試技巧'],
        description: '針對會考數學科目，強化解題技巧，提升應試能力與信心。',
        schedule: '星期二晚上 18:00-21:00',
        weeklyTest: '週考：星期四晚上 18:00-21:00'
      },
      {
        title: '國三理化班',
        image: 'https://readdy.ai/api/search-image?query=Junior%20high%20school%20third%20year%20physics%20and%20chemistry%20exam%20preparation%20with%20students%20aged%2014-15%2C%20teenagers%20reviewing%20scientific%20concepts%20with%20diagrams%20and%20formulas%2C%20modern%20classroom%20with%20exam%20materials%2C%20bright%20clean%20white%20background%2C%20focused%20test%20preparation%20environment%2C%20study%20notes%20and%20practice%20tests%20visible&width=400&height=300&seq=junior3-phy-new&orientation=landscape',
        features: ['會考衝刺', '重點複習', '實驗題型', '答題技巧'],
        description: '理化會考衝刺，掌握重點觀念，熟練實驗題型與計算技巧。',
        schedule: '星期二晚上 18:00-21:00',
        weeklyTest: '週考：星期四晚上 18:00-21:00'
      },
      {
        title: '國三英文班',
        image: 'https://readdy.ai/api/search-image?query=Junior%20high%20school%20third%20year%20English%20exam%20preparation%20with%20students%20aged%2014-15%2C%20teenagers%20practicing%20reading%20comprehension%20and%20grammar%20exercises%2C%20organized%20classroom%20with%20test%20materials%2C%20bright%20clean%20white%20background%2C%20serious%20exam%20preparation%20atmosphere%2C%20practice%20papers%20and%20vocabulary%20lists%20visible&width=400&height=300&seq=junior3-eng-new&orientation=landscape',
        features: ['會考準備', '題型練習', '應試技巧', '閱讀測驗'],
        description: '針對教育會考英文科目，強化解題技巧，提升應試信心與成績。',
        schedule: '星期二晚上 18:00-21:00',
        weeklyTest: '週考：星期四晚上 18:00-21:00'
      },
      {
        title: '國三總複習班',
        image: 'https://readdy.ai/api/search-image?query=Junior%20high%20school%20third%20year%20comprehensive%20review%20class%20with%20students%20aged%2014-15%20preparing%20for%20high%20school%20entrance%20exam%2C%20teenagers%20studying%20all%20subjects%20intensively%20with%20multiple%20textbooks%2C%20organized%20classroom%20with%20exam%20materials%2C%20bright%20clean%20white%20background%2C%20serious%20comprehensive%20exam%20preparation%20atmosphere%2C%20practice%20tests%20visible&width=400&height=300&seq=junior3-review-new&orientation=landscape',
        features: ['全科複習', '模擬考試', '考前衝刺', '重點整理'],
        description: '會考前的全科總複習與衝刺，助學生取得理想成績，進入理想高中。',
        schedule: '星期六下午 14:00-21:00',
        weeklyTest: '週考：星期四晚上 18:00-21:00'
      }
    ]
  };

  const features = [
    {
      icon: 'ri-book-open-line',
      title: '教材系統化',
      description: '使用國際知名教材搭配學校課本，完整銜接學習進度'
    },
    {
      icon: 'ri-microscope-line',
      title: '科學分析',
      description: '定期學習診斷，分析學習成效，調整教學策略'
    },
    {
      icon: 'ri-calendar-check-line',
      title: '定期測驗',
      description: '每月模擬考試，熟悉考試題型與時間掌控'
    },
    {
      icon: 'ri-parent-line',
      title: '家長溝通',
      description: '每週學習報告，讓家長了解孩子學習狀況'
    }
  ];

  const honorRoll = [
    { rank: 2, name: '陳○熙', type: 'school', note: '全校第2名' },
    { rank: 3, name: '紀○羽', type: 'school', note: '全校第3名' },
    { rank: 5, name: '陳○豪', type: 'school', note: '全校第5名' },
    { rank: 8, name: '黃○融', type: 'school', note: '全校第8名' },
    { rank: 9, name: '林○璇', type: 'school', note: '全校第9名' },
    { rank: 14, name: '洪○恩', type: 'school', note: '全校第14名' },
    { rank: 18, name: '施○毅', type: 'school', note: '全校第18名' },
    { rank: 23, name: '黃○瑋', type: 'school', note: '全校第23名' },
    { rank: 28, name: '周○默', type: 'school', note: '全校第28名' },
    { rank: 35, name: '黃○恩', type: 'school', note: '全校第35名' }
  ];

  const classRankings = [
    // 全班第一名
    { rank: 1, name: '王○宇', type: 'class', note: '全班第1名' },
    { rank: 1, name: '李○萱', type: 'class', note: '全班第1名' },
    { rank: 1, name: '張○豪', type: 'class', note: '全班第1名' },
    { rank: 1, name: '陳○慧', type: 'class', note: '全班第1名' },
    { rank: 1, name: '劉○翔', type: 'class', note: '全班第1名' },
    // 全班第二名
    { rank: 2, name: '吳○婷', type: 'class', note: '全班第2名' },
    { rank: 2, name: '許○杰', type: 'class', note: '全班第2名' },
    { rank: 2, name: '楊○雯', type: 'class', note: '全班第2名' },
    // 全班第三名
    { rank: 3, name: '林○峰', type: 'class', note: '全班第3名' },
    { rank: 3, name: '蔡○琪', type: 'class', note: '全班第3名' },
    { rank: 3, name: '鄭○辰', type: 'class', note: '全班第3名' }
  ];

  const mathScores = [
    { score: 98, name: '王○軒', type: 'math', note: '數學98分' },
    { score: 96, name: '李○彤', type: 'math', note: '數學96分' },
    { score: 95, name: '陳○豪', type: 'math', note: '數學95分' },
    { score: 94, name: '陳○瑜', type: 'math', note: '數學94分' },
    { score: 93, name: '劉○廷', type: 'math', note: '數學93分' },
    { score: 92, name: '吳○萱', type: 'math', note: '數學92分' },
    { score: 92, name: '許○豪', type: 'math', note: '數學92分' },
    { score: 91, name: '楊○慈', type: 'math', note: '數學91分' },
    { score: 91, name: '林○澤', type: 'math', note: '數學91分' },
    { score: 90, name: '蔡○恩', type: 'math', note: '數學90分' }
  ];

  const englishScores = [
    { score: 99, name: '鄭○翔', type: 'english', note: '英文99分' },
    { score: 97, name: '黃○雲', type: 'english', note: '英文97分' },
    { score: 96, name: '周○宸', type: 'english', note: '英文96分' },
    { score: 95, name: '蘇○婷', type: 'english', note: '英文95分' },
    { score: 94, name: '何○峻', type: 'english', note: '英文94分' },
    { score: 93, name: '謝○芸', type: 'english', note: '英文93分' },
    { score: 92, name: '廖○豪', type: 'english', note: '英文92分' },
    { score: 92, name: '潘○琪', type: 'english', note: '英文92分' },
    { score: 91, name: '范○辰', type: 'english', note: '英文91分' },
    { score: 90, name: '邱○萱', type: 'english', note: '英文90分' }
  ];

  const scienceScores = [
    { score: 97, name: '胡○宇', type: 'science', note: '自然97分' },
    { score: 96, name: '沈○瑄', type: 'science', note: '自然96分' },
    { score: 95, name: '高○峰', type: 'science', note: '自然95分' },
    { score: 94, name: '趙○雯', type: 'science', note: '自然94分' },
    { score: 93, name: '孫○杰', type: 'science', note: '自然93分' },
    { score: 92, name: '馬○琳', type: 'science', note: '自然92分' },
    { score: 92, name: '羅○安', type: 'science', note: '自然92分' },
    { score: 91, name: '錢○豪', type: 'science', note: '自然91分' },
    { score: 91, name: '徐○慧', type: 'science', note: '自然91分' },
    { score: 90, name: '袁○辰', type: 'science', note: '自然90分' }
  ];

  const [activeCategory, setActiveCategory] = useState('school');

  const categories = [
    { id: 'school', name: '全校排名', icon: 'ri-trophy-fill', color: 'purple' },
    { id: 'class', name: '班級排名', icon: 'ri-star-fill', color: 'blue' },
    { id: 'math', name: '數學高分', icon: 'ri-calculator-line', color: 'green' },
    { id: 'english', name: '英文高分', icon: 'ri-translate-2', color: 'pink' },
    { id: 'science', name: '自然高分', icon: 'ri-test-tube-line', color: 'orange' }
  ];

  const getCurrentData = () => {
    switch (activeCategory) {
      case 'school': return honorRoll;
      case 'class': return classRankings;
      case 'math': return mathScores;
      case 'english': return englishScores;
      case 'science': return scienceScores;
      default: return honorRoll;
    }
  };

  const getIconColor = (type: string) => {
    const category = categories.find(cat => cat.id === type);
    return category ? category.color : 'purple';
  };

  const testimonials = [
    {
      name: '陳○熙',
      content: '感謝老師們的用心教導，讓我在會考中取得全校第2名的好成績！老師不只教會我知識，更教會我如何有效學習。'
    },
    {
      name: '紀○羽',
      content: '在這裡學習的三年，老師總是耐心解答我的問題，讓我從害怕數學變成喜歡數學，真的很感謝！'
    },
    {
      name: '陳○豪',
      content: '補習班的學習氛圍很好，同學們互相鼓勵，老師們專業又親切，讓我在會考中發揮出最好的實力。'
    },
    {
      name: '黃○融',
      content: '理化老師的教學方式讓我豁然開朗，原本最弱的科目變成我最有信心的科目，感謝老師的指導！'
    },
    {
      name: '林○璇',
      content: '從國一開始在這裡學習，老師們見證了我的成長。感謝你們的陪伴和鼓勵，讓我順利考上理想高中。'
    },
    {
      name: '洪○恩',
      content: '補習班的模擬考試讓我提前適應會考節奏，考試時一點都不緊張，真的很有幫助！'
    },
    {
      name: '施○毅',
      content: '英文老師的教學讓我的英文能力突飛猛進，不只會考拿高分，現在高中英文也學得很輕鬆。'
    },
    {
      name: '黃○瑋',
      content: '數學老師總是能用最簡單的方式講解複雜的題目，讓我建立了紮實的數學基礎，非常感謝！'
    },
    {
      name: '周○默',
      content: '在這裡不只學到知識，更學到了讀書方法和時間管理，這些能力讓我受益無窮。'
    },
    {
      name: '王○婷',
      content: '老師們都很關心學生的學習狀況，會針對每個人的弱點加強輔導，讓我進步神速！'
    },
    {
      name: '李○宇',
      content: '補習班的讀書環境很棒，老師教學認真，讓我在會考中各科都拿到A++的好成績。'
    },
    {
      name: '劉○萱',
      content: '感謝理化老師的細心指導，讓我從完全不懂到融會貫通，會考理化拿到滿分！'
    },
    {
      name: '吳○翰',
      content: '國三總複習班的課程規劃很完整，讓我有系統地複習三年所學，會考時信心滿滿。'
    },
    {
      name: '楊○慈',
      content: '老師們不只教課本知識，還會分享解題技巧和應考策略，讓我在考場上如魚得水。'
    },
    {
      name: '許○豪',
      content: '在這裡學習讓我養成良好的讀書習慣，不只會考成功，現在高中課業也能輕鬆應對，真心推薦！'
    }
  ];

  return (
    <>
      <section id="junior-high" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">國中部課程</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              專業師資團隊，系統化教學，幫助學生建立扎實的學科基礎，提升學習成效。
            </p>
          </div>

          {/* 特惠方案區塊 */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {/* 國三特惠方案 */}
            <div className="bg-gradient-to-br from-red-500 to-orange-500 text-white rounded-xl p-6 shadow-xl">
              <div className="flex items-center justify-center mb-4">
                <i className="ri-trophy-line text-3xl mr-2"></i>
                <h3 className="text-2xl font-bold">國三特惠方案</h3>
              </div>
              
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4 mb-4">
                <h4 className="text-xl font-bold text-yellow-300 mb-3">寒假模考戰鬥營</h4>
                <div className="space-y-2 text-sm">
                  <p className="flex items-center">
                    <i className="ri-calendar-line mr-2"></i>
                    2月2號～2月13號
                  </p>
                  <p className="flex items-center">
                    <i className="ri-time-line mr-2"></i>
                    每天下午 1:30-5:00
                  </p>
                  <p className="text-2xl font-bold text-yellow-300 mt-3">費用：2000元</p>
                </div>
              </div>

              <div className="bg-white/10 rounded-lg p-4">
                <h5 className="font-bold mb-2">模考範圍（1-4冊）</h5>
                <div className="grid grid-cols-2 gap-2 text-sm">
                  <div className="flex items-center">
                    <i className="ri-file-text-line mr-1"></i>
                    國文 2份
                  </div>
                  <div className="flex items-center">
                    <i className="ri-calculator-line mr-1"></i>
                    數學 2份
                  </div>
                  <div className="flex items-center">
                    <i className="ri-english-input mr-1"></i>
                    英文 2份
                  </div>
                  <div className="flex items-center">
                    <i className="ri-global-line mr-1"></i>
                    社會 2份
                  </div>
                  <div className="flex items-center">
                    <i className="ri-flask-line mr-1"></i>
                    自然 2份
                  </div>
                </div>
              </div>
            </div>

            {/* 國一特惠方案 */}
            <div className="bg-gradient-to-br from-blue-500 to-cyan-500 text-white rounded-xl p-6 shadow-xl">
              <div className="flex items-center justify-center mb-4">
                <i className="ri-book-open-line text-3xl mr-2"></i>
                <h3 className="text-2xl font-bold">國一特惠方案</h3>
              </div>
              
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4 mb-4">
                <h4 className="text-xl font-bold text-yellow-300 mb-3">寒假免費試讀</h4>
                <p className="text-lg font-bold mb-3">體驗優質教學 完全免費！</p>
              </div>

              <div className="space-y-3">
                <div className="bg-white/10 rounded-lg p-3">
                  <h5 className="font-bold text-yellow-200 mb-2">📚 國一數學</h5>
                  <p className="text-sm">星期三 晚上 6:00-9:00</p>
                </div>
                <div className="bg-white/10 rounded-lg p-3">
                  <h5 className="font-bold text-yellow-200 mb-2">📖 國一英文</h5>
                  <p className="text-sm">星期一 晚上 6:00-9:00</p>
                </div>
              </div>
            </div>

            {/* 國二特惠方案 */}
            <div className="bg-gradient-to-br from-green-500 to-teal-500 text-white rounded-xl p-6 shadow-xl">
              <div className="flex items-center justify-center mb-4">
                <i className="ri-lightbulb-line text-3xl mr-2"></i>
                <h3 className="text-2xl font-bold">國二特惠方案</h3>
              </div>
              
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4 mb-4">
                <h4 className="text-xl font-bold text-yellow-300 mb-3">寒假免費試讀</h4>
                <p className="text-lg font-bold mb-3">體驗優質教學 完全免費！</p>
              </div>

              <div className="space-y-2">
                <div className="bg-white/10 rounded-lg p-2">
                  <h5 className="font-bold text-yellow-200 text-sm mb-1">📚 國二數學</h5>
                  <p className="text-xs">星期五 晚上 6:00-9:00</p>
                </div>
                <div className="bg-white/10 rounded-lg p-2">
                  <h5 className="font-bold text-yellow-200 text-sm mb-1">🔬 國二理化</h5>
                  <p className="text-xs">星期四 晚上 6:00-9:00</p>
                </div>
                <div className="bg-white/10 rounded-lg p-2">
                  <h5 className="font-bold text-yellow-200 text-sm mb-1">📖 國二英文</h5>
                  <p className="text-xs">星期二 晚上 6:00-9:00</p>
                </div>
              </div>
            </div>
          </div>

          {/* 標籤式分類 */}
          <div className="flex justify-center mb-10">
            <div className="inline-flex bg-gray-100 rounded-full p-1.5">
              {['國一', '國二', '國三'].map((grade) => (
                <button
                  key={grade}
                  onClick={() => setActiveGrade(grade)}
                  className={`px-8 py-2.5 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap ${
                    activeGrade === grade
                      ? 'bg-purple-600 text-white shadow-md'
                      : 'text-gray-600 hover:text-gray-800'
                  }`}
                >
                  {grade}
                </button>
              ))}
            </div>
          </div>

          {/* 課程卡片 */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {coursesByGrade[activeGrade as keyof typeof coursesByGrade].map((course, index) => (
              <div key={index} className="bg-gray-50 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                <img 
                  src={course.image}
                  alt={course.title}
                  className="w-full h-56 object-cover object-top"
                />
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-800 mb-3">{course.title}</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">{course.description}</p>
                  <div className="mb-4">
                    <div className="flex items-center text-gray-700 mb-2">
                      <i className="ri-time-line text-purple-500 mr-2"></i>
                      <span className="text-sm">{course.schedule}</span>
                    </div>
                    {course.weeklyTest && (
                      <div className="flex items-center text-gray-700">
                        <i className="ri-calendar-check-line text-orange-500 mr-2"></i>
                        <span className="text-sm">{course.weeklyTest}</span>
                      </div>
                    )}
                  </div>
                  <div className="grid grid-cols-2 gap-2 mb-6">
                    {course.features.map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-center">
                        <i className="ri-check-line text-green-500 mr-2"></i>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <button 
                    onClick={() => setIsTrialModalOpen(true)}
                    className="w-full bg-purple-600 hover:bg-purple-700 text-white py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
                  >
                    預約試聽
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-purple-50 rounded-lg p-8">
            <h3 className="text-2xl font-bold text-gray-800 text-center mb-8">國中部教學特色</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((feature, index) => (
                <div key={index} className="text-center">
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className={`${feature.icon} text-purple-600 text-2xl`}></i>
                  </div>
                  <h4 className="font-semibold mb-2 text-gray-800">{feature.title}</h4>
                  <p className="text-sm text-gray-600">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* 升學成果與榜單 */}
          <div className="mt-12">
            <div className="bg-gradient-to-br from-purple-600 to-pink-500 rounded-lg p-8 shadow-2xl">
              <h3 className="text-3xl font-bold text-white text-center mb-8">
                🎉 國高中榮譽榜 🎉
              </h3>
              
              {/* 統計數據 */}
              <div className="flex items-center justify-center space-x-12 mb-8">
                <div className="text-center">
                  <div className="text-4xl font-bold text-yellow-300">92%</div>
                  <div className="text-white mt-2">會考A級以上</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold text-yellow-300">85%</div>
                  <div className="text-white mt-2">進入理想高中</div>
                </div>
              </div>

              {/* 成績分類標籤 */}
              <div className="flex justify-center mb-6">
                <div className="inline-flex bg-white/20 backdrop-blur-sm rounded-full p-1.5 flex-wrap justify-center">
                  {categories.map((category) => (
                    <button
                      key={category.id}
                      onClick={() => setActiveCategory(category.id)}
                      className={`px-4 py-2 m-1 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap flex items-center space-x-2 ${
                        activeCategory === category.id
                          ? 'bg-white text-purple-700 shadow-lg'
                          : 'text-white/80 hover:text-white hover:bg-white/10'
                      }`}
                    >
                      <i className={`${category.icon} text-sm`}></i>
                      <span className="text-sm">{category.name}</span>
                    </button>
                  ))}
                </div>
              </div>

              {/* 榜單 */}
              <div className="bg-white rounded-lg p-6 mb-6">
                <h4 className="text-2xl font-bold text-center text-purple-700 mb-6">
                  威斯理美語恭喜以上進榜學生
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {getCurrentData().map((student, index) => (
                    <div 
                      key={index}
                      className="flex items-center justify-between bg-gradient-to-r from-purple-50 to-pink-50 p-4 rounded-lg border-l-4 border-purple-500"
                    >
                      <div className="flex items-center space-x-4">
                        <div className={`bg-${getIconColor(activeCategory)}-600 text-white w-12 h-12 rounded-full flex items-center justify-center font-bold`}>
                          {student.rank || student.score}
                        </div>
                        <div>
                          <div className="font-bold text-gray-800">{student.name}</div>
                          <div className="text-xs text-purple-600 font-medium">{student.note}</div>
                        </div>
                      </div>
                      <i className={`${categories.find(cat => cat.id === activeCategory)?.icon || 'ri-trophy-fill'} text-yellow-500 text-2xl`}></i>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* 學生感謝信 */}
          <div className="mt-12">
            <h3 className="text-3xl font-bold text-gray-800 text-center mb-8">
              學生真心推薦
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {testimonials.map((testimonial, index) => (
                <div 
                  key={index}
                  className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-shadow border-t-4 border-purple-500"
                >
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-user-smile-line text-purple-600 text-xl"></i>
                    </div>
                    <div>
                      <div className="font-bold text-gray-800">{testimonial.name}</div>
                    </div>
                  </div>
                  <div className="relative">
                    <i className="ri-double-quotes-l text-purple-200 text-3xl absolute -top-2 -left-2"></i>
                    <p className="text-gray-600 leading-relaxed pl-6 pr-2">
                      {testimonial.content}
                    </p>
                    <i className="ri-double-quotes-r text-purple-200 text-3xl absolute -bottom-2 -right-2"></i>
                  </div>
                  <div className="flex justify-end mt-4">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <TrialModal isOpen={isTrialModalOpen} onClose={() => setIsTrialModalOpen(false)} />
    </>
  );
}
